@if (noticeSession) {
	<div
		class="notice-session-chat card"
		[class.notice-session-chat--floating]="floating"
		[class.notice-session-chat--draggable]="floating && dragEnabled"
		[class.notice-session-chat--minimized]="minimized"
		[class.notice-session-chat--balloon]="balloon"
		[ngStyle]="floatingStyles">
		<header class="notice-session-chat__header card-header" (pointerdown)="onHeaderPointerDown($event)">
			<div>
				<p class="mb-0 fw-600 text-truncate">{{ noticeTitle }}</p>
			</div>
			<div class="notice-session-chat__actions">
				@if (readonlyMode) {
					<span class="badge badge-sm rounded-pill fw-600 border me-2 text-bg-light">Chat em modo leitura</span>
				} @else {
					<span class="badge badge-sm rounded-pill fw-600 border me-2" [ngClass]="statusClass(room?.status)">
						{{ (room?.statusLabel | titlecase) ?? 'Indefinido' }}
					</span>
				}
				@if (floating) {
					<button
						class="btn btn-icon btn-sm me-2"
						type="button"
						(click)="toggleMinimize($event)"
						[attr.aria-pressed]="minimized"
						[attr.title]="minimized ? 'Restaurar chat' : 'Minimizar chat'">
						<span class="visually-hidden">
							{{ minimized ? 'Restaurar chat' : 'Minimizar chat' }}
						</span>
						@if (minimized) {
							<fa-icon icon="chevron-up"></fa-icon>
						} @else {
							<fa-icon icon="chevron-down"></fa-icon>
						}
					</button>
				}
				<!-- No balão o chat já flutua: destacá-lo abriria um segundo chat por cima. -->
				@if (!balloon) {
					<button
						class="btn btn-icon btn-sm me-2"
						type="button"
						(click)="toggleFloatingMode()"
						[attr.aria-pressed]="floating"
						[attr.title]="floating ? 'Fixar chat na página' : 'Exibir chat flutuante'">
						<span class="visually-hidden">
							{{ floating ? 'Fixar chat na página' : 'Exibir chat flutuante' }}
						</span>
						@if (floating) {
							<fa-icon icon="right-left"></fa-icon>
						} @else {
							<fa-icon icon="up-right-from-square"></fa-icon>
						}
					</button>
				}
				<button class="btn btn-icon btn-sm me-2" type="button" (click)="refreshRoom()" [disabled]="ensuringRoom">
					@if (ensuringRoom) {
						<app-pre-loading [inline]="true" [showMessage]="false" [large]="false"></app-pre-loading>
					} @else {
						<fa-icon icon="refresh"></fa-icon>
					}
				</button>
				@if (balloon) {
					<button class="btn btn-icon btn-sm" type="button" (click)="requestClose($event)" title="Fechar chat">
						<span class="visually-hidden">Fechar chat</span>
						<fa-icon icon="xmark"></fa-icon>
					</button>
				}
				@if (floating) {
					<button class="btn btn-icon btn-sm text-danger" type="button" (click)="closeFloatingChat($event)" [attr.title]="'Fechar chat'">
						<span class="visually-hidden">Fechar chat</span>
						<fa-icon icon="xmark"></fa-icon>
					</button>
				}
			</div>
		</header>
		@if (phases.length > 0 && !minimized) {
			<div class="card-header py-1 px-3 d-flex align-items-center gap-2 border-top-0">
				<small class="text-muted flex-shrink-0 fw-600">Fase de lances</small>
				<select
					class="form-select form-select-sm text-truncate"
					name="chatPhaseFilter"
					[ngModel]="phaseFilterId ?? ''"
					(ngModelChange)="onPhaseFilterChange($event)">
					<option value="">Todas as mensagens</option>
					@for (phase of phases; track phase.id) {
						<option [value]="phase.id">{{ phase.externalCode || 'Fase' }}</option>
					}
				</select>
			</div>
		}
		@if (realtimeNotice !== 'none') {
			<!--
				Dois níveis, e não um só: "reconectando" era falso no caso mais comum, em que o socket está
				conectado e apenas não recebe nada — aí quem serve a tela é o polling REST, e dizer que a
				conexão caiu assusta sem motivo. A histerese de entrada e saída fica no RealtimeStatusNotice.
			-->
			<div
				class="alert d-flex align-items-center gap-2 mb-0 rounded-0 py-1 px-3 small fw-600"
				[class.alert-warning]="realtimeNotice === 'offline'"
				[class.alert-info]="realtimeNotice === 'syncing'">
				<span class="spinner-border spinner-border-sm"></span>
				@if (realtimeNotice === 'offline') {
					Sem conexão em tempo real — reconectando...
				} @else {
					Sincronizando com o servidor...
				}
			</div>
		}
		<div class="notice-session-chat__body card-body p-0" [class.notice-session-chat__body--hidden]="minimized">
			@if (room) {
				@if (room?.participants?.length && !readonlyMode) {
					<div class="notice-session-chat__presence">
						@for (participant of orderParticipants(room.participants); track participant.id) {
							<div class="presence-pill" [ngbTooltip]="handlerParticipantName(participant)" container="body">
								@if (isTyping(participant.member.id)) {
									<span class="typing-indicator" aria-label="Digitando">
										<span class="typing-indicator__dot"></span>
										<span class="typing-indicator__dot"></span>
										<span class="typing-indicator__dot"></span>
									</span>
								} @else {
									<span class="presence-dot" [ngClass]="presenceClass(participant.member.id, participant.member.role)"></span>
								}
								<span class="text-truncate">{{ handlerParticipantName(participant, true) }}</span>
							</div>
						}
						<small class="text-muted ms-auto">{{ onlineSummary }}</small>
					</div>
				}
				<div class="notice-session-chat__messages w-100" #messagesContainer (scroll)="onMessagesScroll()">
					@if (messagesLoadingMore) {
						<div class="d-flex w-100 justify-content-center align-items-center py-2">
							<div class="text-center text-muted">
								<span class="spinner-border spinner-border-sm me-2"></span>
								Carregando mensagens antigas...
							</div>
						</div>
					}
					@for (message of messages; track message.id) {
						<div class="d-flex mb-2" [class.justify-content-end]="message.supplier">
							<div class="message-bubble" [class.user]="message.supplier" [class.owner]="message.owner" [class.system]="message.system">
								<div class="notice-session-chat__message-meta">
									@if (message.system) {
										<strong>
											<fa-icon icon="robot"></fa-icon>
											Sistema
										</strong>
									} @else if (message.supplier) {
										<strong>{{ message.sender.useNickName ? message.sender.nickName : message.sender?.name }}</strong>
									} @else {
										<strong>Agente de Contratação</strong>
									}
								</div>
								<div class="notice-session-chat__message-content lh-sm">
									@if (message.system) {
										<div [innerHTML]="message.handlerContent"></div>
									} @else {
										{{ message.content?.trimStart() }}
									}
									<small class="time text-dark">{{ message.created | date: 'shortTime' }}</small>
								</div>
							</div>
						</div>
					}
					@if (!messagesLoading && !messages.length) {
						<div class="notice-session-chat__empty">
							<div class="d-flex w-100 h-100 justify-content-center align-items-center">
								<app-empty-data [message]="'Nenhuma mensagem enviada até o momento.'"></app-empty-data>
							</div>
						</div>
					}
					@if (messagesLoading && !messages.length) {
						<div class="d-flex w-100 h-100 justify-content-center align-items-center">
							<div class="text-center text-muted">
								<span class="spinner-border spinner-border-sm me-2"></span>
								Carregando mensagens...
							</div>
						</div>
					}
				</div>
				@if (!readonlyMode) {
					<form class="notice-session-chat__composer" [formGroup]="messageForm">
						<div class="notice-session-chat__composer-field">
							<textarea
								#messageInput
								class="form-control"
								rows="1"
								maxlength="2000"
								placeholder="Escreva uma mensagem"
								formControlName="message"
								(input)="handleComposerInput($event)"
								(keydown)="handleComposerKeydown($event)"
								(focus)="handleComposerFocus()"
								(blur)="handleComposerBlur()"></textarea>
							<button
								*permissions="'dispute.chat.create'"
								type="button"
								class="btn btn-primary notice-session-chat__composer-send"
								(click)="sendMessage()"
								[disabled]="messageForm.invalid || sendingMessage || realtimeUnstable"
								aria-label="Enviar mensagem">
								@if (sendingMessage) {
									<span class="spinner-border spinner-border-sm"></span>
								}
								@if (!sendingMessage) {
									<span>
										<fa-icon icon="paper-plane"></fa-icon>
									</span>
								}
							</button>
						</div>
					</form>
				}
			} @else {
				@if (ensuringRoom) {
					<div class="notice-session-chat__state">
						<span class="spinner-border spinner-border-sm me-2"></span>
						Preparando sala do chat...
					</div>
				}
				@if (!ensuringRoom && readonlyMode) {
					<div class="notice-session-chat__state">
						<app-empty-data [message]="'O chat aparece aqui quando a sessão for aberta.'"></app-empty-data>
					</div>
				}
				@if (!ensuringRoom && !readonlyMode) {
					<div class="notice-session-chat__state">
						<app-empty-data [message]="'Nenhuma sala vinculada a esta sessão.'">
							<p class="text-muted mb-0">A sala será habilitada assim que a sessão for aberta.</p>
						</app-empty-data>
					</div>
				}
			}
		</div>
	</div>
} @else {
	<div class="notice-session-chat__placeholder">
		<h5>Selecione uma sessão do edital</h5>
		<p class="text-muted mb-0">Escolha uma sessão para visualizar e participar do chat correspondente.</p>
	</div>
}
